import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, map, catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import * as ImeiActions from './imei.actions';
import { ImeiApiService } from '../services/imei-api.service';
import { ErrorService, LoaderService } from '@common/util-foundation';
import { IMEIStatusEnum } from '@sky/util-models';

@Injectable()
export class ImeiEffects {
  loadImei$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ImeiActions.loadImei),
      switchMap(({ imei }) =>
        this.imeiApiService.imeiValidate({ imei }).pipe(
          map((imeiApiResult) =>
            ImeiActions.loadImeiSuccess({ imeiApiResult })
          ),
          catchError((error: HttpErrorResponse) => {
            if (
              error.error?.status === IMEIStatusEnum.Invalid ||
              error.error?.status === IMEIStatusEnum.NotFound
            ) {
              return of(
                ImeiActions.loadImeiFailure({
                  error: {
                    name: error.error.status,
                    message: error.error.message,
                  },
                })
              );
            }
            this.handleError();
            return of(ImeiActions.loadImeiFailure({ error }));
          })
        )
      )
    )
  );

  showLoader$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ImeiActions.loadImei),
        tap(() => this.loaderService.showLoader())
      ),
    { dispatch: false }
  );

  hideLoader$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ImeiActions.loadImeiSuccess, ImeiActions.loadImeiFailure),
        tap(() => this.loaderService.hideLoader())
      ),
    { dispatch: false }
  );

  handleError() {
    this.errorService.handleError();
  }

  constructor(
    private actions$: Actions,
    private readonly errorService: ErrorService,
    private imeiApiService: ImeiApiService,
    private loaderService: LoaderService
  ) {}
}
